module.exports = __webpack_public_path__ + "assets/img/b0559ffd3a0b95789a58c910884c9bf0.svg";